<template>
	<div class="dankal-image-upload">
		<div v-if="list && list.length >0" style="width: 96%;">
			<div class="upload-item" v-for="(item,index) in list" :key="index">
				<div class="upload-file">
					<img class="file-icon" :src="fileIcon(item.file_type)" />
					<span>{{ item.file_name }}</span>
				</div>
				<img class	="close" src="@/assets/images/download.png" @click="onDownload(item.url)" >
				
			</div>
		</div>
	</div>
</template>

<script>
	import {
		uploadImgFile,
		qiniuInfo
	} from '@/api/common';
	import {
		mapState,
		mapActions
	} from 'vuex';
	import {
		imgDomain
	} from '@/configs/env';

	export default {
		name: 'DankalImageUpload',
		data() {
			return {
				minNum: 0,
				list: [],
				imgDomain,
				toast: '',
				file_type: this.type, //图片还是视频
				showInput: true
			}
		},
		created() {
			setTimeout(()=>{
				this.list = this.onloadImage
			},500)
		},
		props: {
			limit: {
				type: Number,
				default: 5,
			},
			quatity: {
				type: Number,
				default: 0.6,
			},
			type: {
				type: String,
				default: 'image',
			},
			disabled: {
				type: Boolean,
				default: false
			},
			onloadImage: {
				type: Array,
				require: false,
				default () {
					return []
				}
			},
			isBanner: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			...mapState(['bucket_domain_token']),
		},
		mounted() {
			if (this.isBanner) {
				if (this.onloadImage) {
					this.showInput = false;
				}
			}
			console.log(this.list, '图片列表')
		},
		methods: {
			...mapActions(['getUrlAndTokenOfImageUpload']),
			fileIcon(type){
				if(type.indexOf('pdf') != -1){
					return require('@/assets/images/ppt.png')
				}
				if(type.indexOf('doc') != -1){
					return require('@/assets/images/word.png')
				}
				if(type.indexOf('excel') != -1){
					return require('@/assets/images/excel.png')
				}
			},
			onSelected() {
				const {
					limit,
					list
				} = this;

				if (limit && list.length >= limit) {
					this.$message(`只能上传${limit}张图片`)
					return;
				}
				this.$refs.input.click();
			},
			onDownload(url){
				window.open(this.imgDomain + url)
			},
			onDeleted(index) {
				this.list.splice(index, 1)
				//不置空 删除之后上传同张图片无法出发change事件
				this.showInput = true;
				this.$refs.input.value = '';
				this.$emit('input', this.list);
			},

			onFileChanged(event) {
				const file = event.target.files[0];
				console.log(file);
				const {
					type,
					size
				} = file;
				const isLt1M = size / 1024 / 1024 < 1;
				const isLt2M = size / 1024 / 1024 < 2;
				//this.getUrlAndTokenOfImageUpload();
				if (!file) return;
				if (type.indexOf('image') !== -1) {
					this.file_type = 'image'
				}
				if (type.indexOf('video') !== -1) {
					this.file_type = 'video'
				}
				// if (type != 'application/pdf') {
				// 	this.$message("图片上传限制pdf文件格式");
				// 	return;
				// }
				// if (!isLt1M) {
				// 	this.$message("图片上传限制1M");
				// 	return;
				// }
				this.upload(file);
			},
			async upload(file) {
				//首先获取七牛信息
				console.log(file)
				// const { data, status } = await qiniuInfo();

				//  if (status !== 200) return 
				const formData = new FormData();
				formData.append('file', file);
				var url = "/common/UploadFile";
				const res = await uploadImgFile(url, formData).catch(() => {});
				console.log(res)
				if (res.status === 200) {
					if (this.isBanner) {
						this.list = [];
						this.showInput = false;
					}
					this.list.push({
						file_type: file.type,
						file_name: file.name,
						url: res.data.result
					});
					this.$emit('input', this.list);
				}
			},
		},
		watch: {
			isBanner(val) {
				if (val) {
					if (this.onloadImage) {
						this.showInput = false;
					}
				}
			},
			onloadImage: {
				handler(newVal, oldVal) {
					console.log('newVal', newVal)
					if (newVal.length > 0) {
						this.disabled = false;
						this.showInput = false;
						this.list = [];
						this.list = newVal;
					} else {
						this.disabled = false;
						this.showInput = true;
						this.list = []
					}
				},
				immediate: true
				
			}
		}
	};
</script>

<style lang="less" scoped>
	.dankal-image-upload {
		display: flex;
		flex-wrap: inherit;

		.upload-item {
			position: relative;
			min-width: 100%;
			height: max-content;
			background: #F9FAFB;
			margin: 20px 0px 20px 0px;
			display: flex;
			border-radius: 8px 8px 8px 8px;
			justify-content: space-between;
			align-items: center;
			.upload-file{
				width: 100%;
				height: 48px;
				
				display: flex;
				justify-items: start;
				align-items: center;
			}
			.file-icon{
				width: 25px;
				height: 25px;
				margin-left: 10px;
			}
			.upload_img {
				width: 150px;
				height: 150px;
				object-fit: cover;
			}

			.close {
				width: 15px;
				height: 15px;
				cursor: pointer;
				margin-right: 10px;
			}
		}

		.add-box {
			display: flex;
			flex-direction: column;
			padding-left: 20px;
			margin-top: 20px;

			.add {
				width: 150px;
				height: 150px;
			}

			span {
				color: #CFCFCF;
				font-size: .22rem;
			}
		}
	}
</style>
